import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import BusinessDirectorsTable from '../business-directors-table/BusinessDirectorsTable';

class BusinessDirectorsTab extends Component {
  render() {
    const { storeInitArgs, onStoreConstruction, localStorageKey, loading, userStore } = this.props;
    return (
      <BusinessDirectorsTable
        loading={loading}
        storeInitArgs={storeInitArgs}
        onStoreConstruction={onStoreConstruction}
        localStorageKey={localStorageKey}
        userStore={userStore}
      />
    );
  }
}

BusinessDirectorsTab.propTypes = {
  storeInitArgs: PropTypes.object,
  onStoreConstruction: PropTypes.func,
  localStorageKey: PropTypes.string,
  userStore: PropTypes.object,
  loading: PropTypes.bool,
};

BusinessDirectorsTab.defaultProps = {
  storeInitArgs: {},
  onStoreConstruction: () => {},
  localStorageKey: '',
  userStore: {},
  loading: false,
};

export default observer(BusinessDirectorsTab);
